{
  "name": "status-page",
  "version": "0.2.1",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build --configuration production",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "lint": "ng lint",
    "cibuild": "ng lint && ng build --configuration production && ng test --watch=false --coverage",
    "devbuild": "ng build --c development",
    "testbuild": "ng build --c test"
  },
  "private": true,
  "engines": {
    "node": "^24.15.0 || >=26.0.0"
  },
  "dependencies": {
    "@angular/cdk": "^22.1.6",
    "@angular/common": "^22.1.6",
    "@angular/compiler": "^22.1.6",
    "@angular/core": "^22.1.6",
    "@angular/forms": "^22.1.6",
    "@angular/material": "^22.1.6",
    "@angular/platform-browser": "^22.1.6",
    "@angular/router": "^22.1.6",
    "@ngx-translate/core": "^18.0.0",
    "@ngx-translate/http-loader": "^18.0.0",
    "ngx-logger": "^5.0.12",
    "rxjs": "~7.8.2",
    "tslib": "^2.8.1",
    "zone.js": "~0.16.3"
  },
  "devDependencies": {
    "@angular/build": "^22.1.8",
    "@angular/cli": "^22.1.8",
    "@angular/compiler-cli": "^22.1.6",
    "@eslint/js": "^10.0.1",
    "@types/node": "^24.13.4",
    "@vitest/coverage-v8": "4.1.11",
    "angular-eslint": "^22.5.0",
    "eslint": "^10.10.0",
    "istanbul-lib-instrument": "^6.0.3",
    "jsdom": "^30.0.1",
    "typescript": "~6.0.3",
    "typescript-eslint": "^8.70.0",
    "vitest": "4.1.11"
  }
}
